<template>
  <div class="tag-menu">
    <div class="tag-menu__inner">
      <h5 class="tag-menu__title">
        Edit Slide
      </h5>

      <div class="tag-menu__col">
        <div class="tag-menu__block">
          <label>
            Label
            <localised-field-indicator />
          </label>
          <input
            v-model="value.label[activeLanguage.code]"
            class="form-control"
            type="text"
            placeholder="label"
            @input="$emit('recordAction')"
          />
        </div>

        <div class="tag-menu__block tag-menu__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">
            Should slide expand
          </label>
          <toggle-button
            v-model="value.shouldSlideExpand"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
            @input="$emit('recordAction')"
          />
        </div>

        <div class="tag-menu__block tag-menu__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">
            Should start active
          </label>
          <toggle-button
            v-model="value.shouldStartActive"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
      </div>

      <div class="tag-menu__col element-grow">
        <div class="tag-menu__col">
          <div class="tag-menu__block">
            <label>Background Image Override</label>
            <input-asset
              v-model="value.backgroundImageOverride"
              defaultCategory="tagImage"
            />
          </div>
        </div>
      </div>

      <div class="tag-menu__col">
        <div class="tag-menu__block">
          <label>Slide Media</label>
          <input-asset
            :returnid="true"
            v-model="value.assetId"
            defaultCategory="tagImage"
          />
        </div>
      </div>

      <div class="tag-menu__col tag-menu__col--last buttons-row">
        <button
          class="btn btn-remove"
          @click="$emit('remove-slide', value._id)"
        >
          Remove Slide
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputAsset from "@/components/InputAsset";

export default {
  components: {
    InputAsset
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(["activeLanguage"])
  },

  watch: {
    value: {
      deep: true,
      handler(newValue) {
        if (newValue.type === "slide") {
          this.$emit("updateSlide", newValue);
        }
      }
    },

    // whenever the picked asset id changes, refresh the embedded asset object
    "value.assetId"(newId) {
      this.updateAsset(newId);
    }
  },

  methods: {
    async updateAsset(id) {
      // clear asset if no id
      if (!id) {
        this.$set(this.value, "asset", null);
        return;
      }

      try {
        const asset = await this.$store.dispatch("GET_ASSET_BY_ID", id);
        // mirror old behaviour from CardUpdateInteractiveTags
        this.$set(this.value, "asset", asset);
      } catch (err) {
        console.error("Failed to update asset", err);
        if (this.$notify) {
          this.$notify({
            message: "Error loading asset preview.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning"
          });
        }
      }
    }
  }
};
</script>
